export const SET = "incomingQuotes/SET";
export const SET_INCOMING_QUOTE_WITH_ALL_LINE_ITEMS =
  "incomingQuoteWithAllLineItemsDetail/SET";



// WEBPACK FOOTER //
// ./app/modules/IncomingQuotes/actionTypes.js